import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: 'input[vnmPlaceholder]'
})
export class PlaceholderDirective {
  @Input() set vnmPlaceholder(value: string) {
    this.translateService.get(value).subscribe((text) => {
      this.renderer.setAttribute(this.input, 'placeholder', text);
    });
  }

  private get input(): HTMLInputElement {
    return this.element.nativeElement as HTMLInputElement;
  }

  constructor(private element: ElementRef, private translateService: TranslateService, private renderer: Renderer2) {}
}
